import React, { useState, useEffect } from "react";
import Pagination from "react-js-pagination";
import QuanLyChoVayApi from "../../../../service/quanLyChoVayApi";
import { formatNumber } from "utils/currencyFormat";
import { getDate } from "utils/formatDate";

export const LanThanhToan = ({ choVayId }) => {
  const searchInit = {
    choVayId: choVayId,
    pageIndex: 1,
    pageSize: 5,
  };
  const [dataSearchLanDongLai, UpdateDataSearchLanDongLai] =
    useState(searchInit);
  const dataInit = {
    List: [],
    TongCanThanhToan: 0,
    TongPhiKhac: 0,
    TongPhiKho: 0,
    TongPhiPhat: 0,
    TongThanhToan: 0,
    TongTienGoc: 0,
    TongTienLai: 0,
    totalRow: 0,
  };
  const [dataLanDongLai, UpdateDataLanDongLai] = useState(dataInit);
  useEffect(() => {
    DanhSachLanThanhToan();
  }, []);
  const DanhSachLanThanhToan = () => {
    QuanLyChoVayApi.lanThanhToan1(
      dataSearchLanDongLai.choVayId,
      dataSearchLanDongLai.pageIndex,
      dataSearchLanDongLai.pageSize
    ).then((response) => {
      UpdateDataLanDongLai({
        ...dataLanDongLai,
        List: response.data.List,
        TongCanThanhToan: response.data.TongCanThanhToan,
        TongPhiKhac: response.data.TongPhiKhac,
        TongPhiKho: response.data.TongPhiKho,
        TongPhiPhat: response.data.TongPhiPhat,
        TongThanhToan: response.data.TongThanhToan,
        TongTienGoc: response.data.TongTienGoc,
        TongTienLai: response.data.TongTienLai,
        totalRow: response.data.totalRow,
      });
    });
  };

  const PhanTrang = (index) => {
    dataSearchLanDongLai.pageIndex = index;
    DanhSachLanThanhToan();
  };
  const [showLaiAll, setShowLai] = useState(false);
  const [showPhiKhoAll, setShowPhiKho] = useState(false);
  const [showGopAll, setShowGop] = useState(false);
  const listItem = () => {
    return (
      dataLanDongLai.List != null &&
      dataLanDongLai.List.map((item, index) => {
        let showLai =
          item.Type !== 2 || (item.Type === 2 && item.StatusPaidHo === 2);
        if (showLai != showLaiAll) setShowLai(showLai);

        let showGoc =
          item.Type !== 2 || (item.Type === 2 && item.StatusPaidHo === 2);
        let showGop = item.Type === 2 && item.StatusPaidHo === 1;
        if (showGop != showGopAll) setShowGop(showGop);
        let isShowPhiKho =
          item.Type === 3 && item.Type !== 2 && item.Type !== 1;
        if (isShowPhiKho != showPhiKhoAll) setShowPhiKho(isShowPhiKho);

        //Lấy Lần đóng lãi
        let lstTP = [];
        let lstLanThanhToan = [];
        if (item.ThuPaid) lstTP = item.ThuPaid.split(",");

        lstTP.map((itemPaid, idexTP) => {
          var itemPaids = itemPaid.split("#");
          lstLanThanhToan.push(
            <span className="color7">
              <span className="color7">
                {formatNumber(itemPaids[2].replace(".00", ""))}
              </span>
              ({getDate(itemPaids[1])})
            </span>
          );
        });

        return (
          <>
            <tr className="active color7">
              <td>{item.IndexId}</td>
              <td>
                <span>{getDate(item.Time)}</span>
              </td>
              {showLai && (
                <td className="text-right red">
                  <span className="">{formatNumber(item.ValuePaid)}</span>
                </td>
              )}

              <td className="text-right red">
                {showGoc && (
                  <span className="">{formatNumber(item.ValueGoc)}</span>
                )}
              </td>

              {showGop && (
                <td className="text-right red">
                  <span className="">
                    {formatNumber(item.ValueGoc + item.ValuePaid)}
                  </span>
                </td>
              )}

              <td className="text-right red">
                <span className="">{formatNumber(item.OtheFee)}</span>
              </td>
              {isShowPhiKho && (
                <td className="text-right red">
                  <span className="">{formatNumber(item.PhiKho)}</span>
                </td>
              )}
              <td className="text-right red">
                <span className="">{formatNumber(item.Paided)}</span>
              </td>

              <td className="text-right ">{lstLanThanhToan}</td>
            </tr>
          </>
        );
      })
    );
  };

  return (
    <>
      <div className="row">
        <div className="Left808x200  Table-main-morman table-noboder-new col-xl-12 col-lg-12">
          <div className="table-responsive table-new1">
            <table
              className="table table-bordered table-hover color7  table-rounded"
              cellSpacing="0"
              rules="all"
              border="0"
              id=""
              style={{ borderWidth: "0px", borderCollapse: "collapse" }}
            >
              <tbody>
                <tr className="table-header">
                  <th className="w-stt  color7-bold">STT</th>
                  <th className="w-10 color7-bold">Ngày thanh toán</th>
                  {showLaiAll && (
                    <th className="text-right w-15 color7-bold">
                      Tiền lãi
                      <br />
                      <span className="color-do-bold">
                        {formatNumber(dataLanDongLai.TongTienLai)}
                      </span>
                    </th>
                  )}

                  <th className="text-right w-15 color7-bold">
                    Tiền gốc
                    <br />
                    <span className="color-do-bold">
                      {formatNumber(dataLanDongLai.TongTienGoc)}
                    </span>
                  </th>

                  {showGopAll && (
                    <th className="text-right w-15 color7-bold">
                      Tiền góp
                      <br />
                      <span className="color-do-bold">
                        {formatNumber(
                          dataLanDongLai.TongTienGoc +
                            dataLanDongLai.TongTienLai
                        )}
                      </span>
                    </th>
                  )}

                  <th className="text-right w-10 color7-bold">
                    Phí khác
                    <br />
                    <span className="color-do-bold">
                      {formatNumber(dataLanDongLai.TongPhiKhac)}
                    </span>
                  </th>

                  {showPhiKhoAll && (
                    <th className="text-right w-10 color7-bold">
                      Phí kho
                      <br />
                      <span className="color-do-bold">
                        {formatNumber(dataLanDongLai.TongPhiKho)}
                      </span>
                    </th>
                  )}
                  <th className="text-right w-15 color7-bold">
                    Ðã thanh toán
                    <br />
                    <span className="color-xanh-bold">
                      {formatNumber(dataLanDongLai.TongThanhToan)}
                    </span>
                  </th>
                  <th className="w-25 text-right color7-bold">Các lần đóng</th>
                </tr>
              </tbody>
              {listItem()}
            </table>
          </div>
        </div>
      </div>

      <div className="table-responsive-new table-2"></div>
      <div className="footer-page-new">
        <div className="row">
          <div className="col-xl-12 col-lg-12">
            <div className="paniation-new d-flex just-end just-center-mobile">
              <nav aria-label="Page navigation">
                <Pagination
                  activePage={dataSearchLanDongLai.pageIndex}
                  itemsCountPerPage={dataSearchLanDongLai.pageSize}
                  totalItemsCount={dataLanDongLai.totalRow}
                  pageRangeDisplayed={5}
                  onChange={PhanTrang}
                  itemClass="page-item border-none"
                  linkClass="page-link border-none"
                  activeClass="active"
                />
              </nav>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
